import { rem } from "polished";
import { ThemeKind } from "src/types";

import { ColorLabels } from "@/components/editor/utils/use-color";

import { createThemeFactory } from "../utils";
import preview from "./assets/preview.jpg";
import previewSmall from "./assets/preview-small.jpg";
import { colorSet, fonts } from "./constants";
import createTemplate from "./create-template";
import blocks from "./resolved-blocks";
import selections from "./selections";

export default createThemeFactory(() => ({
  kind: ThemeKind.DEFAULT,
  name: "Seldon",
  categories: "Webinars, Meetups",
  smallPreviewUrl: previewSmall,
  previewUrl: preview,
  previewColor: "#F0DDFA",
  blocks,
  selections,
  enabled: true,
  requiresPaymentPlanUpgrade: false,
  colorSet,
  fonts,
  typography: {
    patterns: {
      headingOne: {
        fontSize: rem(64),
        fontWeight: 700,
        color: ColorLabels.PRIMARY_FONT,
        lineHeight: rem(72),
        viewport: {
          mobile: {
            fontSize: rem(40),
            lineHeight: rem(52),
          },
        },
      },
      headingTwo: {
        fontSize: rem(32),
        fontWeight: 700,
        color: ColorLabels.PRIMARY_FONT,
        lineHeight: rem(40),
        marginBottom: rem(40),
        viewport: {
          mobile: {
            fontSize: rem(28),
            lineHeight: rem(34),
            marginBottom: rem(32),
          },
        },
      },
      headingThree: {
        fontSize: rem(24),
        fontWeight: 600,
        color: ColorLabels.PRIMARY_FONT,
        lineHeight: rem(32),
        marginBottom: rem(8),
        viewport: {
          mobile: {
            fontSize: rem(22),
          },
        },
      },
      headingFour: {
        fontSize: rem(20),
        fontWeight: 600,
        color: ColorLabels.PRIMARY_FONT,
        lineHeight: rem(32),
        marginBottom: rem(8),
      },
      paragraph: {
        fontSize: rem(18),
        fontWeight: 400,
        color: ColorLabels.SECONDARY_FONT,
        lineHeight: rem(33),
        viewport: {
          mobile: {
            fontSize: rem(16),
            lineHeight: rem(28),
          },
        },
      },
      bodyOne: {
        fontSize: rem(18),
        fontWeight: 400,
        color: ColorLabels.SECONDARY_FONT,
        lineHeight: rem(33),
        viewport: {
          mobile: {
            fontSize: rem(16),
            lineHeight: rem(28),
          },
        },
      },
      description: {
        fontSize: rem(14),
        fontWeight: 400,
        color: ColorLabels.SECONDARY_FONT,
        lineHeight: rem(26),
      },
      bodyTwo: {
        fontSize: rem(14),
        fontWeight: 400,
        color: ColorLabels.SECONDARY_FONT,
        lineHeight: rem(26),
      },
      labelOne: {
        fontSize: rem(16),
        fontWeight: 400,
        color: ColorLabels.PRIMARY_FONT,
        lineHeight: rem(32),
      },
      labelTwo: {
        fontSize: rem(14),
        fontWeight: 400,
        color: ColorLabels.SECONDARY_FONT,
        lineHeight: rem(32),
      },
    },
  },
  createTemplate,
}));
